import CalendarLeftPane from './CalendarLeftPane';
import CalendarLeftPaneAsOverlay from './CalendarLeftPaneAsOverlay';
import { observer } from 'mobx-react-lite';
import { Module } from 'owa-bootstrap';
import {
    CalendarModuleHamburgerButton,
    CalendarModuleNewEventButton,
} from 'owa-calendar-commandbar';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isLeftRailVisible } from 'owa-left-rail-utils/lib/isLeftRailVisible';
import isOfficeRailEnabled from 'owa-left-rail-utils/lib/isOfficeRailEnabled';
import { ModuleSwitcherLeftRail } from 'owa-module-switcher';
import { ResizeHandle } from 'owa-resize-handle';
import * as React from 'react';
import {
    setCalendarLeftPaneWidth,
    toggleCalendarLeftPaneExpansion,
    shouldShowLeftNavAsOverlay,
    getIsLeftNavShown,
    shouldCommandingStretchLeft,
} from 'owa-calendar-layout';

const styles = require('./CalendarModule.scss');

/**
 * Autofocus should be disabled on initial page load to respect normal tab flow,
 * but then become enabled after the first time the button is clicked as a workaround
 * to "preserve" focus on the button post-click (even though the component actually
 * unmounts and remounts in a different DOM position to accomodate the left nav changes).
 *
 * This workaround can be removed if/when the DOM can be restructured/simplified to ensure that
 * the initial component instance can be preserved rather than unmounted and remounted elsewhere.
 */
let shouldAutoFocusHamburgerButton: boolean = false;

export default observer(function CalendarLeftNav() {
    const calendarSidePanelIsExpanded: boolean = getIsLeftNavShown();

    return (
        <>
            <div className={styles.leftPane}>
                {(!calendarSidePanelIsExpanded ||
                    isLeftRailVisible(Module.Calendar) ||
                    shouldShowLeftNavAsOverlay()) &&
                    !isOfficeRailEnabled(Module.Calendar) && (
                        <div className={styles.leftPaneCollapsed}>
                            {!shouldCommandingStretchLeft() && (
                                <div className={styles.leftPaneCollapsedCommandBar}>
                                    <CalendarModuleHamburgerButton
                                        autoFocus={shouldAutoFocusHamburgerButton}
                                        isPaneExpanded={calendarSidePanelIsExpanded}
                                        toggleHamburgerButton={
                                            toggleCalendarLeftPaneExpansionOnClick
                                        }
                                    />
                                    <CalendarModuleNewEventButton />
                                </div>
                            )}
                            {isHostAppFeatureEnabled('calendarOfficeRail') && (
                                <ModuleSwitcherLeftRail selectedModule={Module.Calendar} />
                            )}
                        </div>
                    )}
                {shouldShowLeftNavAsOverlay() && calendarSidePanelIsExpanded ? (
                    <CalendarLeftPaneAsOverlay
                        toggleHamburgerButton={toggleCalendarLeftPaneExpansionOnClick}
                    />
                ) : (
                    <CalendarLeftPane
                        toggleHamburgerButton={toggleCalendarLeftPaneExpansionOnClick}
                        shouldAutoFocusHamburgerButton={shouldAutoFocusHamburgerButton}
                    />
                )}
            </div>
            {/* add resize handler only when folder pane is not shown as an overlay */}
            {!shouldShowLeftNavAsOverlay() && (
                <ResizeHandle className={styles.paddingTop} onResize={leftNavResizeHandler} />
            )}
        </>
    );
});

/*
 * An onResize callback used to update the user config with the new value for the left nav width.
 * @param leftNavWidth - the measured width from the left left rail to the resize handle
 */
function leftNavResizeHandler(leftNavWidth: number): void {
    setCalendarLeftPaneWidth(leftNavWidth);
}

/**
 * Gets called when the hamburger is clicked
 */
export function toggleCalendarLeftPaneExpansionOnClick() {
    shouldAutoFocusHamburgerButton = true;
    toggleCalendarLeftPaneExpansion();
}
